import * as angular from "angular";
import { CampaignDataProvider } from "../../data-provider/campaign.dp";
import { Campaign } from "../../models/campaign.model";
import { PermissionCheck } from "../../shared/permission";
import { Utils } from "../../helper/utils.helper";
import { DashboardDataProvider } from "../../data-provider/dashboard.dp";
import { Dashboard } from "../../models/dashboard.model";
import { DashboardWidgetFilter } from "../../models/dashboard-widget-filter.model";
import { DialogUtils } from "../../helper/dialog.helper";
import { Organisation } from "../../models/organisation.model";
import { User } from "../../models/user.model";
import { UserDataProvider } from "../../data-provider/user.dp";

let DashboardsPageComponent = {
    selector: "vcDashboardsPage",
    templateUrl: "/angular/components/dashboard/dashboards-page.component.html",
    bindings: {},
    controller: class DashboardsPageController {
        public isLeaderView: boolean;
        public description: string;
        public activeCampaign: Campaign;
        public widgets: any[] = [];

        public filter?: DashboardWidgetFilter;
        private readonly $cookies: any;
        private readonly $scope: any;
        private readonly localStorage: any;
        private readonly dialog: DialogUtils;

        private dashboardDataProvider: DashboardDataProvider;
        public campaignDataProvider: CampaignDataProvider;
        public permissionCheck: PermissionCheck;
        public activeOrganisation: Organisation;
        public __env: any;
        private utils: Utils;

        public loadingPage: boolean = true;
        public dashboard: Dashboard;
        public dashboards: Dashboard[];
        public hasSampleData: boolean;
        public downloading: boolean;
        public user: User;

        constructor(
            __env: any,
            __app_type: string,
            $scope: any,
            $cookies: any,
            $window: any,
            CampaignDataProvider: CampaignDataProvider,
            DashboardDataProvider: DashboardDataProvider,
            UserDataProvider: UserDataProvider,
            PermissionCheck: PermissionCheck,
            DialogUtils: DialogUtils,
            Utils: Utils
        ) {
            this.dashboardDataProvider = DashboardDataProvider;
            this.campaignDataProvider = CampaignDataProvider;
            this.permissionCheck = PermissionCheck;
            this.__env = __env;
            this.$cookies = $cookies;
            this.$scope = $scope;
            this.dialog = DialogUtils;
            this.utils = Utils;
            this.utils.accessCheck();
            this.utils.runWootric();
            this.filter = new DashboardWidgetFilter();
            this.activeCampaign = this.campaignDataProvider.getActiveCampaign();
            this.isLeaderView = __app_type == "LEADER";
            this.user = UserDataProvider.getActiveUser();

            if (
                !this.activeCampaign.campaignname ||
                this.activeCampaign.campaignname == ""
            ) {
                $window.location = "/#/welcome";
            } else if (
                this.permissionCheck.hasPermission("GETTING_STARTED") &&
                this.$cookies.get("firstlogin") == "1" &&
                this.$cookies.get("started") != "1"
            ) {
                this.dialog.show({
                    component: "vc-setup-selection",
                    scope: this.$scope,
                    clickOutsideToClose: false,
                    backdropBlur: true,
                    size: "large",
                    locals: {},
                    ariaLabel: "Setup Selection",
                });
            }

            CampaignDataProvider.getOrganisations().then(
                (organisation: Organisation): void => {
                    this.activeOrganisation = organisation;
                }
            );

            this.localStorage = this.activeCampaign.getLocalStorage();

            if (!this.localStorage.resultPage) {
                this.localStorage.resultPage = {};
                this.activeCampaign.saveLocalStorage();
            }

            CampaignDataProvider.getOrganisations().then(
                (organisation: Organisation): void => {
                    this.loadDashboards();
                }
            );

            this.permissionCheck.getFeaturePermissions();
            this.campaignDataProvider.hasSampleData().then((hasSampleData) => {
                this.hasSampleData = hasSampleData;
                if (!hasSampleData) {
                    this.campaignDataProvider
                        .allowedToEnableSampleData()
                        .then();
                }
            });
        }

        loadDashboards() {
            this.dashboardDataProvider
                .all()
                .then((dashboards: Dashboard[]): void => {
                    this.loadingPage = false;
                    this.dashboards = dashboards;
                    const canEditAll: boolean =
                        this.permissionCheck.hasPermission("EDIT_DASHBOARD");
                    const userId: number = parseInt(this.user.uid);
                    for (const dash of this.dashboards) {
                        dash.hasEditPermission =
                            canEditAll || userId == dash.creator;
                    }
                    let selectedDash = this.dashboards[0];
                    if (
                        this.localStorage &&
                        this.localStorage.resultPage &&
                        this.localStorage.resultPage.selectedDashboardId
                    ) {
                        angular.forEach(this.dashboards, (dash) => {
                            if (
                                dash.id ==
                                this.localStorage.resultPage.selectedDashboardId
                            ) {
                                selectedDash = dash;
                            }
                        });
                    }
                    this.switchDashboard(selectedDash);
                });
        }

        createDashboard(ev: any) {
            this.dialog
                .show({
                    component: "vc-create-dashboard",
                    targetEvent: ev,
                    scope: this.$scope,
                    clickOutsideToClose: false,
                    ariaLabel: "Create New Dashboard",
                    locals: {},
                })
                .then((returnedDashboard: Dashboard) => {
                    this.dashboard = angular.copy(returnedDashboard);
                });
        }

        filterDashboards(accessType: string): Dashboard[] {
            if (this.dashboards) {
                if (accessType == "private") {
                    return this.dashboards.filter((dashboard: Dashboard) => {
                        return dashboard.uid != null;
                    });
                } else {
                    return this.dashboards.filter((dashboard: Dashboard) => {
                        return dashboard.uid == null;
                    });
                }
            }
            return [];
        }

        switchDashboard(dashboard: Dashboard): void {
            if (!this.dashboard || dashboard.id != this.dashboard.id) {
                this.dashboard = dashboard;
            }
        }
    },
};

angular
    .module("dashboard")
    .component(DashboardsPageComponent.selector, DashboardsPageComponent);
